// Ui
import Modal from 'ui3/Modal/Modal';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';

import styles from './FiltersToggle.module.scss';

type FiltersToggleProps = {
  filtersModalIsVisible: boolean;
  toggleFiltersVisibility: () => void;
  children?: JSX.Element;
  /** When true, modal container gets extra top padding on mobile when smart app banner is visible. */
  addSmartBannerPaddingToFilters?: boolean;
};

const FiltersToggle = ({
  filtersModalIsVisible,
  toggleFiltersVisibility,
  children,
  addSmartBannerPaddingToFilters = false,
}: FiltersToggleProps) => {
  return (
    <>
      <button
        className={styles.filterToggleButton}
        onClick={toggleFiltersVisibility}
        type="button"
      >
        <span className={styles.filterToggleButtonTitle}>Filter</span>
        <MillionsIcon
          name="filterOutline"
          className={styles.filterToggleButtonIcon}
        />
      </button>

      <Modal
        size="large"
        className={styles.filtersModal}
        open={filtersModalIsVisible}
        onClose={toggleFiltersVisibility}
        focusTrapped={false}
        fullPageOnMobile
        blockScroll={false}
        containerClassName={
          addSmartBannerPaddingToFilters
            ? 'filtersModalWithSmartBannerPadding'
            : undefined
        }
      >
        {children}
      </Modal>
    </>
  );
};

export default FiltersToggle;
